import React from "react";

import Base from "../Base";

import Button from "../../Button";
import ContentComponent from "../../Content";

import { IContentProps } from "./interfaces";

import { Body, Container, Footer, Head, Icon, Loader, Title } from "./styles";

const variants = {
  hidden: { y: -40 },
  visible: {
    y: 0,
    transition: { ease: [0.25, 1, 0.5, 1], duration: 0.4 },
  },
};

const Content: React.FC<IContentProps> = (props) => {
  return (
    <Base>
      <Container
        initial="hidden"
        animate="visible"
        size={props.size}
        variants={variants}
      >
        <Head>
          {props.icon && <Icon name={props.icon} />}

          <Title>{props.title}</Title>
        </Head>

        {props.loader?.status ? (
          <Loader>
            <ContentComponent.Loader message={props.loader?.message} />
          </Loader>
        ) : (
          <>
            <Body>{props.children}</Body>

            {(props.onCancel || props.onSubmit) && (
              <Footer>
                {props.onCancel && (
                  <Button
                    kind="smooth"
                    type="button"
                    onClick={props.onCancel.onClick}
                    isDisabled={props.onCancel.disabled}
                  >
                    {props.onCancel.text}
                  </Button>
                )}

                {props.onSubmit && (
                  <Button
                    onClick={props.onSubmit.onClick}
                    isDisabled={props.onSubmit.disabled}
                  >
                    {props.onSubmit.text}
                  </Button>
                )}
              </Footer>
            )}
          </>
        )}
      </Container>
    </Base>
  );
};

Content.defaultProps = {
  size: "medium",
};

export default Content;
